if (typeof EditSelection === 'undefined') {
  class EditSelection extends HTMLElement {
    constructor() {
      super()

      this.modalTriggers = this.querySelectorAll('.js-edit-selection-item .js-selection-modal-trigger');
      this.modalTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.toggleModal);
      })
    }

    toggleModal (e) {
      e.preventDefault();
      const item = e.target.closest('.js-edit-selection-item');
      const modal = item.querySelector('.js-edit-selection-modal');

      if (modal) modal.classList.toggle('hidden');
    }
  }

  if(customElements.get('edit-selection') === undefined) {
    customElements.define('edit-selection', EditSelection);
  }
}
